// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CancellationReasonType } from './cancellation-reason-type';
import { CancellationRequest } from './cancellation-request';
import { CancellationRequestDetailStatus } from './cancellation-request-detail-status';
import { JoDetail } from './jo-detail';
import { CancellationReasonTypeEnum } from './enums';
import { CancellationRequestDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CancellationRequestDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String */
  cancellationExplanation?: string;
  /** Enum FK cancellationReasonType */
  cancellationReasonTypeId!: CancellationReasonTypeEnum;
  /** Enum FK cancellationRequestDetailStatus */
  cancellationRequestDetailStatusId!: CancellationRequestDetailStatusEnum;
  /** Int32 FK cancellationRequest */
  cancellationRequestId!: number;
  /** String */
  cancellationStatusExplanation?: string;
  /** DateTimeOffset */
  cancellationStatusTs!: Date;
  /** Boolean */
  isAdminApproved!: boolean;
  /** Boolean */
  isOverride!: boolean;
  /** Int32 FK joDetail */
  joDetailId!: number;
  /** Guid */
  proximityCancellationRequestDetailId?: string;
  /** Guid */
  proximityOrigCancellationRequestDetailId?: string;
  /** Int32 */
  qty!: number;
  /** FK cancellationReasonTypeId */
  cancellationReasonType!: CancellationReasonType;
  /** FK cancellationRequestId */
  cancellationRequest!: CancellationRequest;
  /** FK cancellationRequestDetailStatusId */
  cancellationRequestDetailStatus!: CancellationRequestDetailStatus;
  /** FK joDetailId */
  joDetail!: JoDetail;
}

